<template>
  <div class="contact">

    <section class="contact-head">
      <b-row>
        <b-col md="7">
          <h1>
          Contact me here
          </h1>
          <br>
          <a href="mailto:ronnel.sanchez@gmail.com" class="btn btn-primary btn-lg btn-mail mb-5">
            ronnel.sanchez@gmail.com
          </a>
          <ul class="list-unstyled list list-icon">
            <li class="icon-skype">
              <b>Skype</b><a href="skype:ronnel.sanchez_1?chat">ronnel.sanchez_1</a>
            </li>
            <li class="icon-whatsapp">
              <b>WhatsApp / Mobile</b><a href="https://api.whatsapp.com/send?phone=639272197146">+63 927 219 7146</a>
            </li>
            <li class="icon-telegram">
              <b>Telegram</b><a href="https://telegram.me/ronnelsanchez">@ronnelsanchez</a>
            </li>
          </ul>
        </b-col>
      </b-row>
    </section>

    <section>
      <b-row>
        <b-col md="7">
          <h3>Portfolios</h3>
          <ul class="list-unstyled list list-icon">
            <li class="icon-dribbble">
              <b>Dribbble</b><a href="https://dribbble.com/ronnelsanchez">https://dribbble.com/ronnelsanchez</a>
            </li>
            <li class="icon-behance">
              <b>Behance</b><a href="https://www.behance.net/ronnelsanchez">https://www.behance.net/ronnelsanchez</a>
            </li>
          </ul>
        </b-col>
      </b-row>
    </section>

    <section>
      <b-row>
        <b-col md="7">
          <h3>Links</h3>
          <ul class="list-unstyled list list-icon">
            <li class="icon-linkedin">
              <b>LinkedIn</b><a href="https://ph.linkedin.com/in/ronnelsanchez">https://ph.linkedin.com/in/ronnelsanchez</a>
            </li>
            <li class="icon-github">
              <b>GitHub</b><a href="https://github.com/ronnelsanchez">https://github.com/ronnelsanchez</a>
            </li>
          </ul>
        </b-col>
      </b-row>
    </section>

  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>



// WEBPACK FOOTER //
// src/views/Contact.vue